/**
 * Bookmarks API Endpoints
 */

import { api } from '../client';
import type { CreateBookmarkRequest } from '../types';
import { BookmarkResponseSchema, BookmarkResponsePageSchema } from '../schemas';
import { parseResponse } from '../validation';
import { randomUUID } from '@/lib/uuid';

export const bookmarksApi = {
  /**
   * Create a bookmark from a message
   */
  create: (request: CreateBookmarkRequest) =>
    api.post('/bookmarks', request).then(
      (res) => parseResponse(BookmarkResponseSchema, res, 'POST /bookmarks'),
    ),

  /**
   * List user's bookmarks
   */
  list: (limit = 50, offset = 0) =>
    api.getPage(`/bookmarks?limit=${limit}&offset=${offset}`, {
      schema: BookmarkResponsePageSchema,
    }),

  /**
   * Get a bookmark by ID with enrichment data
   */
  get: (id: string) =>
    api.get(`/bookmarks/${id}`).then(
      (res) => parseResponse(BookmarkResponseSchema, res, `GET /bookmarks/${id}`),
    ),

  /**
   * Manually trigger enrichment for a bookmark
   */
  enrich: (id: string) =>
    api.post(
      `/bookmarks/${id}/enrich`,
      undefined,
      { headers: { 'Idempotency-Key': randomUUID() } },
    ).then(
      (res) => parseResponse(BookmarkResponseSchema, res, `POST /bookmarks/${id}/enrich`),
    ),
};
